import { useQuery } from '@tanstack/react-query';

import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { getQuestions } from 'services/reviews';

export const useGetActiveQuestionsQuery = () =>
  useQuery([REACT_QUERY_KEYS.reviewQuestionList.activeQuestions], () =>
    getQuestions({ offset: 0, limit: 2000, label: null, source: 'review' })
  );
export const useGetArchiveQuestionsQuery = () =>
  useQuery([REACT_QUERY_KEYS.reviewQuestionList.archivedQuestions], () =>
    getQuestions({ offset: 0, limit: 2000, label: 'ARCHIVE', source: 'review' })
  );

export const useGetSampleQuestionsQuery = () =>
  useQuery([REACT_QUERY_KEYS.reviewQuestionList.sampleQuestions], () =>
    getQuestions({ offset: 0, limit: 2000, label: 'SAMPLE', source: 'review' })
  );
